import React from "react";
import { FaArrowUp, FaArrowDown } from "react-icons/fa";

function ScrollButtons() {
  const scrollToTop = () => {
    window.scrollTo({
      top: 0,
      behavior: "smooth",
    });
  };

  const scrollToBottom = () => {
    window.scrollTo({
      top: document.documentElement.scrollHeight,
      behavior: "smooth",
    });
  };

  return (
    <div className="scroll-buttons">
      <button
        className="scroll-btn"
        onClick={scrollToTop}
        aria-label="Scroll to top"
      >
        <FaArrowUp />
      </button>

      <button
        className="scroll-btn"
        onClick={scrollToBottom}
        aria-label="Scroll to bottom"
      >
        <FaArrowDown />
      </button>
    </div>
  );
}

export default ScrollButtons;
